export default __webpack_public_path__ + "static/gta_roofing_7-6596bebb5fee72f934f1b5cfac07ecd9.jpg";